import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { PrimaryTab } from 'components/Tabs';
import { ParticipantCard } from 'components/Cards';

const MixDivision = ({ mixDivision, viewData, mixLevels }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const [activeTab, setActiveTab] = useState(mixLevels[0] || '');
  const [participantsCount, setParticipantsCount] = useState({});

  useEffect(() => {
    const counts = mixLevels.reduce((acc, level) => {
      acc[level] =
        mixDivision.filter((item) => item.tournament_level === level).length ||
        '';
      return acc;
    }, {});
    setParticipantsCount(counts);
  }, [mixDivision, mixLevels]);

  useEffect(() => {
    if (viewData && viewData.gender_id === 3) {
      setActiveTab(mixLevels[0]);
      setTimeout(() => {
        window.localStorage.removeItem('formData');
      }, 1000);
    }
  }, [viewData, mixLevels]);

  return (
    <Box width={'100%'}>
      <Typography
        variant={isMd ? 'h4' : 'h5'}
        fontWeight={700}
        color={theme.palette.darkGrey[700]}
        marginBottom={'32px'}
      >
        {t('mixDivision')} {mixDivision.length > 0 && `(${mixDivision.length})`}
      </Typography>
      <Box
        maxWidth={
          mixLevels.length > 5 ? '100vw' : `${mixLevels.length * 218}px`
        }
        marginBottom={'48px'}
        display={'flex'}
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent={'space-between'}
        border={`1px solid ${theme.palette.darkGrey[300]}`}
        borderRadius={'8px'}
      >
        {mixLevels.map((level, index) => (
          <PrimaryTab
            key={index}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={level}
            participants={participantsCount[level]}
          />
        ))}
      </Box>
      <Grid container spacing={{ xs: '24px', sm: '32px' }}>
        {mixDivision
          .filter((item) => item.tournament_level === activeTab)
          .map((item) => (
            <Grid item xs={12} sm={4} md={3} key={item.player1_id}>
              <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
                alignItems={'center'}
                borderRadius={'8px'}
                padding={'12px'}
                bgcolor={theme.palette.base.white}
                gap={{ xs: '4px', sm: '8px' }}
                boxShadow={theme.shadows[1]}
                width={'100%'}
                height={'100%'}
              >
                <ParticipantCard
                  fullName={item.player1_full_name}
                  avatar={item.player1_image}
                />
                {item.player2_id && (
                  <ParticipantCard
                    fullName={item.player2_full_name}
                    avatar={item.player2_image}
                  />
                )}
              </Box>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default MixDivision;
